import { betterFetch } from './helper';

/**
 * find experiment and return values
 * @param {string} experimentName - requested experiment name
 * @returns {Promise<Response>} experiment details
 */
export const findExperiment = function findExperiment(experimentName) {
  const baseUrl = 'https://bucketing.service.exp.vip.nordstrom.com/api/variations';
  const url = `${baseUrl}?experiment_names=${experimentName}`;

  return betterFetch(url);
};
